import styled from "styled-components/macro";
import { PRICING_MOBILE_BREAKPOINT } from "../constants";

export const StyledMadeBy = styled.div`
  padding-top: 40px;
  padding-bottom: 40px;

  h1 {
    font-family: "GT Super Text";
    margin: auto;
    text-align: center;
    padding: 20px;
    padding-top: 40px;
    font-size: 54px;
    &.by-writers-headline {
      font-size: 36px;
      color: #f5f2e4;
    }
  }

  > span {
    font-family: "GT Super Text";
    &:nth-of-type(1) {
      color: #f5f2e4;
      font-size: 24px;
      opacity: 0.4;
    }

    &:nth-of-type(2),
    &:nth-of-type(3) {
      display: block;
      color: #f5f2e4;
      font-size: 22px;
      width: 450px;
      margin: auto;
      margin-bottom: 80px;
      margin-top: 20px;
    }

    &:nth-of-type(3) {
      margin-top: 80px;
      font-family: "Inter";
      line-height: 1.6rem;
      font-size: 18px;
      color: #7b7668;

      a {
        color: #7b7668;
        text-decoration: underline;
      }
    }

    &.by-writers-sub-headline {
      display: block;
      font-size: 15px;
      margin-bottom: 50px;
    }

    &.write-faster {
      margin-top: 80px;
      line-height: 1.4em;
      margin-bottom: 54px;
    }

    &.want-to-see {
      font-size: 14px;
      margin-bottom: 20px;
      margin-top: 80px;
    }

    clear: both;
  }

  background: #2a2315;
  padding: 30px;
  text-align: center;
  color: white;
  min-height: 500px;

  button.try-it-button {
    background: #f5f2e4;
    color: #2a2315;
    font-size: 20px;
    font-family: "Inter";
    font-weight: 100;
    border-radius: 30px;
    margin-bottom: 70px;
  }

  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    padding-left: 0;
    padding-right: 0;

    h1 {
      font-size: 30px !important;
    }
    span {
      font-weight: 500;
    }
    > span {
      &:nth-of-type(2) {
        width: fit-content;
        font-weight: 600;
        max-width: 100%;
      }
      &:nth-of-type(3) {
        width: auto;
        height: 0;
        visibility: hidden;
        max-width: 100%;
      }
      &.by-writers-sub-headline {
        font-size: 22px;
        line-height: 124.2%;
      }
      &.write-faster {
        margin-top: 150px;
      }
    }

    .write-faster {
      margin-top: 50px !important;
      font-weight: 600;
    }
  }
`;

export const StyledTile = styled.div`
  width: 200px;
  background: rgba(132, 120, 96, 0.1);
  position: relative;
  margin: 8px;
  padding: 12px;
  font-family: "Inter";
  border-radius: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #f5f2e4;

  .above-text {
    font-size: 10px;
  }

  ${({ overlayImage }) =>
    overlayImage &&
    `
 &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(${overlayImage}) no-repeat center center;
    background-size: cover;
  }

`}

  img {
    max-width: 90%;
    display: block;
    margin: auto;

    &[src$="svg"] {
      max-width: 40px;
    }
    &[src$="button.png"] {
      max-height: 45px;
    }
  }

  span {
    display: block;
    font-size: 13px;
    padding: 10px;
  }

  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    min-height: 140px;
    border-radius: 40px;
    margin: 15px;

    .above-text {
      font-size: 16px;
    }

    span {
      font-size: 20px;
      opacity: 0.7;
    }

    img {
      &[src$="svg"] {
        max-width: 50px;
        margin: 10px auto;
      }
      &[src$="button.png"] {
        max-height: 60px;
      }
    }
  }
`;

export const StyledTileGrid = styled.div`
  clear: both;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 1085px;
  margin: auto;

  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    display: flex;
    width: 100%;

    ${StyledTile} {
      float: left;
      clear: left;
      width: 90%;
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

export const StyledSlideshow = styled.div`
  height: 440px;
  padding-top: 80px;
  padding-bottom: 80px;
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;

  img {
    width: 500px;
    float: left;
  }

  ul {
    max-width: 250px;
    float: left;
    margin-left: 30px;

    li {
      font-family: "Inter";
      text-align: left;
      font-size: 18px;
      margin-bottom: 15px;
    }
  }

  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    flex-direction: column;
    align-items: space-around;
    min-height: 140px;
    padding: 12px;
    height: auto;
    .slideshow-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      min-height: 140px;
    }

    ul {
      margin-left: 0;
      width: 100%;
      max-width: 100%;
      text-align: center;

      li {
        text-align: center;
        font-weight: 500;
        font-size: 22px;
        line-height: 124.2%;
        opacity: 0.8;
        margin-top: 8px;
      }
    }
  }
`;

export const StyledSlideshowDescription = styled.li`
  opacity: 0.5;
  color: #f5f2e4;
  line-height: 1.6rem;
  cursor: pointer;
  ${({ selected }) => selected && `opacity: .8; padding-left: 20px;`}
  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    ${({ selected }) => (!selected ? `display: none;` : `padding-left: 0px`)}
  }
`;

export const StyledVideo = styled.video`
  transition: opacity 1000ms;
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0;
  transition: opacity 500ms;
  max-height: 450px;
  border-radius: 30px;
  ${({ selected }) => selected && `opacity: 1;`}

  &:nth-child(1) {
    transform: scale(1.2);
    right: 60px;
  }

  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    align-self: center;
    text-align: center;
    max-width: 90%;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    min-height: 12.5rem;
    max-height: 12.5rem;

    &:nth-child(1) {
      max-width: 75%;
      right: 0;
      transform: unset;
    }
  }
`;

export const StyledVideoContainer = styled.div`
  position: relative;
  height: 450px;
  width: 750px;

  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    height: 220px;
    padding: 10px 30px 0px 30px;
    max-width: 80vw;
  }
`;

export const StyledBorderEdge = styled.div`
  position: absolute;
  width: 5px;
  height: 50px;
  margin-left: 29px;
  background: #27ae60;
  transition: margin 500ms;
  border-radius: 3px;
`;

export const StyledDescriptionContainer = styled.div`
  position: relative;
  margin-top: 110px;
  margin-left: 30px;

  ${StyledBorderEdge} {
    ${({ selected }) => selected && `margin-top: ${selected && selected * 66}px;`}
  }

  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    ${StyledBorderEdge} {
      display: none;
    }
    margin-top: -12px;
    margin-left: 0px;
    height: 50px;
    clear: both;
  }
`;

export const StyledChevronLeft = styled.div`
  display: none;
  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    display: block;
    float: left;
    width: 30px;
    height: 100px;
    margin-top: -25px;
    margin-left: 0vw;
    align-self: center;
    background: url("/assets/pricing/chevron-left.svg") no-repeat center center;
    cursor: pointer;
  }
`;

export const StyledChevronRight = styled.div`
  display: none;
  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    display: block;
    float: right;
    height: 100px;
    width: 30px;
    margin-top: -20px;
    margin-right: 0vw;
    align-self: center;
    background: url("/assets/pricing/chevron-right.svg") no-repeat center center;
    cursor: pointer;
  }
`;
